import { resources } from "@constants/hardcoded-strings";
import { formatServiceTemplate } from "@formatters/service-templates/service-template-formatter";
import { AxnCompany } from "@idw-types/data/reference-data/axn";
import { ServiceTemplateDetails } from "@idw-types/data/service-template-details/service-template-details";
import { addServiceTemplate } from "@redux/actions/service-templates-actions";
import { createServiceTemplateRequest } from "@requests/management-console/create-service-template";
import { displaySuccessModal, logAndDisplayErrorModal } from "@utils/app-alert-util";
import { toObject } from "@utils/object-util";
import { Dispatch } from "redux";

export const createServiceTemplateReduxRequest = (dispatch: Dispatch) => async (
    serviceTemplate: Partial<ServiceTemplateDetails>, axnCompanies: Array<AxnCompany>
    
) => {
    const { data, error, body } = await createServiceTemplateRequest(serviceTemplate);
    if (data?.response) {
        const axnCompaniesMap = toObject<AxnCompany>(axnCompanies, 'id');
        dispatch(addServiceTemplate(formatServiceTemplate(data.response, axnCompaniesMap)));
        displaySuccessModal(
            dispatch,
            resources.requests.createServiceTemplate.success.title,
            resources.requests.createServiceTemplate.success.message
        );
        return data.response;
    } else if (error) {
        logAndDisplayErrorModal(
            dispatch,
            error,
            resources.requests.createServiceTemplate.error.title,
            resources.requests.createServiceTemplate.error.message,
            null,
            null,
            body
        );
    }

    return null;
};